import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PartnerWorkspacePage from "@/pages/partner/PartnerWorkspacePage";
export const Route = createFileRoute("/partner/work")({
  head: () =>
    pageHead(
      "Partner Work",
      "Your authorized Partner company workspace.",
      "/partner/work",
      true,
    ),
  component: () => <PartnerWorkspacePage section="work" />,
});
